import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import * as Actions from './actions';
/**
 * Adds to or replaces existing comments with new comments.
 * @param {object} comments - Object where each key is a card slug and
 * each value is an array of comments.
 * @param {array} newComments - Array of comments with the same streamID.
 * @param {boolean} clearCurrentComments - If we should add new comments to the corresponding array
 * or replace.
 */

function addComments(comments, newComments, clearCurrentComments, addToFront) {
  var streamID = get(newComments[0], 'streamId', '');
  var existingComments = clearCurrentComments ? [] : get(comments, streamID, []);
  var updatedComments = addToFront ? newComments.concat(existingComments) : existingComments.concat(newComments);
  return _objectSpread({}, comments, _defineProperty({}, streamID, updatedComments));
}

function handleCommentsLoaded(state, action) {
  var streamID = action.streamID,
      comments = action.comments,
      hasMoreComments = action.hasMoreComments,
      nextCommentsTimestamp = action.nextCommentsTimestamp,
      clearCurrentComments = action.clearCurrentComments;
  var newComments = get(comments, streamID, []);
  var commentsList = addComments(state.commentsList, newComments, clearCurrentComments);
  return _objectSpread({}, state, {
    commentsList: commentsList,
    hasMoreComments: hasMoreComments,
    nextCommentsTimestamp: nextCommentsTimestamp,
    loading: false
  });
}

function handleCommentPosted(state, action) {
  var newComments = [action.comment];
  var commentsList = addComments(state.commentsList, newComments, false, true);
  return _objectSpread({}, state, {
    posting: false,
    postedComment: action.comment,
    commentsList: commentsList
  });
}

function handleCommentVoted(state, action) {
  var commentID = action.commentID,
      streamID = action.streamID,
      vote = action.vote,
      allowNegativeVotes = action.allowNegativeVotes,
      voteButtonPressed = action.voteButtonPressed;
  var comments = get(state.commentsList, streamID, []);
  var updatedComments = comments.map(function (comment) {
    if (comment.ID === commentID) {
      if (allowNegativeVotes) {
        var negVotes = comment.negVotes || 0;
        var posVotes = comment.posVotes || 0; // not pretty, but no time to refactor rn

        if (vote === 'pos') {
          posVotes += 1;
        } else if (vote === 'neg') {
          negVotes += 1;
        } else if (vote === 'none') {
          if (voteButtonPressed === 'pos') {
            posVotes -= 1;
          } else if (voteButtonPressed === 'neg') {
            negVotes -= 1;
          }
        } // tab design doesn't need TotalVotes, but keeping state obj consistent for now


        return _objectSpread({}, comment, {
          vote: vote,
          posVotes: posVotes,
          negVotes: negVotes,
          TotalVotes: posVotes + negVotes
        });
      } // Add or subtract a vote, minimum 0


      var numVotes = vote === 'pos' ? comment.TotalVotes + 1 : Math.max(comment.TotalVotes - 1, 0);
      return _objectSpread({}, comment, {
        vote: vote,
        posVotes: numVotes,
        TotalVotes: numVotes
      });
    }

    return comment;
  });
  return _objectSpread({}, state, {
    voting: false,
    commentsList: _objectSpread({}, state.commentsList, _defineProperty({}, streamID, updatedComments))
  });
}

function handleSetUserComment(state, action) {
  return _objectSpread({}, state, {
    loading: false,
    postedComment: action.comment
  });
}

function handleLogout(state) {
  return _objectSpread({}, state, {
    user: undefined,
    postedComment: undefined,
    postError: undefined
  });
}

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Actions.GIGYA_LOADED:
      return _objectSpread({}, state, action.gigya);

    case Actions.GIGYA_RATINGS_LOADED:
      return _objectSpread({}, state, {
        ratings: action.ratings
      });

    case Actions.GIGYA_COMMENTS_LOADING:
      return _objectSpread({}, state, {
        loading: true
      });

    case Actions.GIGYA_COMMENTS_LOADED:
      return handleCommentsLoaded(state, action);

    case Actions.GIGYA_COMMENT_POSTING:
      return _objectSpread({}, state, {
        posting: true
      });

    case Actions.GIGYA_COMMENT_POSTED:
      return handleCommentPosted(state, action);

    case Actions.GIGYA_COMMENT_POSTED_FAIL:
      return _objectSpread({}, state, {
        postError: action.error,
        posting: false
      });

    case Actions.GIGYA_COMMENT_VOTING:
      return _objectSpread({}, state, {
        voting: true
      });

    case Actions.GIGYA_COMMENT_VOTED:
      return handleCommentVoted(state, action);

    case Actions.GIGYA_COMMENT_VOTED_FAIL:
      return _objectSpread({}, state, {
        voteError: action.error,
        voting: false
      });

    case Actions.GIGYA_LOGIN:
      return _objectSpread({}, state, {
        user: action.user
      });

    case Actions.GIGYA_LOGOUT:
      return handleLogout(state);

    case Actions.SET_USER_COMMENT:
      return handleSetUserComment(state, action);

    case Actions.POST_LOGIN_ACTIONS:
      return _objectSpread({}, state, {
        postLoginActionsInProgress: true
      });

    case Actions.POST_LOGIN_ACTIONS_COMPLETE:
      return _objectSpread({}, state, {
        postLoginActionsInProgress: false
      });

    default:
      return state;
  }
});